import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/ShoppingCart'

const {
  Shopping_Cart_Clicked_Remove_Btn,
  Shopping_Cart_Clicked_Checkout_Btn,
  Shopping_Cart_Clicked_Continue_Shopping_Btn,
  Add_To_Cart_Modal_Clicked_Keep_Shopping_Btn,
  Shopping_Cart_Clicked_Other_Popular_Item
} = eventNames

export default {
  Shopping_Cart_Clicked_Remove_Btn({ itemId }: { itemId: string }): void {
    fireHeapEvent(Shopping_Cart_Clicked_Remove_Btn, { itemId })
  },
  Shopping_Cart_Clicked_Checkout_Btn({
    cartId,
    label
  }: {
    cartId?: string | null
    label: string
  }): void {
    fireHeapEvent(Shopping_Cart_Clicked_Checkout_Btn, { cartId, label })
  },
  Shopping_Cart_Clicked_Continue_Shopping_Btn({
    cartId
  }: {
    cartId: string | null | undefined
  }): void {
    fireHeapEvent(Shopping_Cart_Clicked_Continue_Shopping_Btn, { cartId })
  },
  Add_To_Cart_Modal_Clicked_Keep_Shopping_Btn(): void {
    fireHeapEvent(Add_To_Cart_Modal_Clicked_Keep_Shopping_Btn)
  },
  Shopping_Cart_Clicked_Other_Popular_Item(args: {
    productName?: string | null
    productId?: string | null
  }): void {
    fireHeapEvent(Shopping_Cart_Clicked_Other_Popular_Item, args)
  }
}
